import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const UniqueTrussTypesD = iotsUtils.fromList(constants.report.volumetrics.uniqueTrussTypes);
